let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kh61f")).then(() => parcelRequire('7s028'));